/*global Show*/
import {$, scrollToPos} from "./utils";
import {device} from "./UserDevice";
import {VIEW_START} from "../showPage";

export default class EsroHelper {
    constructor($esro) {
        this._data = {};
        this._esro = $esro;
        this.esroloaded = false;
        this.esroloadedCount = 0;

        this.init();
    }

    init() {
        //get iframe postmessages:
        $(window).on("message", (e) => {
            this.esroPostCallback(e.originalEvent);
        });


        //Attach the basket changed event handler
        this._esro.attachEventHandler("basketChanged",this.basketHandler);
        //Attach the client status changed event handler
        this._esro.attachEventHandler("clientDetailsChanged", this.clientHandler);
        //Attach the iframe navigated event handler
        this._esro.attachEventHandler("navigationRequired", this.navigationHandler);
        //Attach error event handler
        this._esro.attachEventHandler("error", this.handleError);
        //this._esro.getJsonFeed("events", "eventsListCallback");

        //not needed >  getEventdFeed('events', 'getFeedCb');


    }
    getEventdFeed = (feedName, callback) => {
        var baseURL = 'https://www.kupat.co.il//';

        jQuery.ajax({
            type         : "GET",
            url          : baseURL + "feed/" + feedName + "?json&callback=" + callback,
            dataType     : "jsonp",
            jsonp        : false,
            jsonpCallback: callback,
            success      : function(response) {
                this.esroEvents = response.feed.Events.Event;

                if(Show.hasOneShow) {
                    Show.openIframe(jQuery('#order'));
                }

                if(typeof callback == 'function') {
                    callback();
                }

            }

        });

    };
    basketHandler = (basket) => {
        var basketString = "No items in basket";
        var currentBasket = basket;
        if(basket != null) {
            var items;
            items = basket.Tickets.length;
            //thanku!
            if(basket.OrderNumber) {
                console.log('OrderNumber : ' + basket.OrderNumber);
                console.log('totalValue : ' + basket.totalValue);
                console.log('ReferenceNumber : ' + basket.ReferenceNumber);
                this.showThankuPage('CONFIRMATION.ASPX');
            }
        }
    };
    clientHandler = (client) => {
        if(client == null) {
        }
        else {
            console.log(client);

        }
    };
    handleError = (err) => {
        console.log(err);
    };
    navigationHandler = (pageName) => {
        this.esroloadedCount++;
        if(this.esroloaded && Show.iframePage != 'DEFAULT' && pageName.toUpperCase() == 'DEFAULT') {
            window.top.location = site.siteUrl;
        }
        if(pageName == 'Order.aspx') {
            Show.stage = 'iframe';
        }
        if(Show.stage !== "start") {
            if(Show.waitForLoad) {
                var to = $('#frame').offset().top - 40;
                scrollToPos(to, function() {
                    Show.loader(false);
                    Show.waitForLoad = false;
                });

            }
        }
        this.esroloaded = this.esroloadedCount >= 1 && pageName.toUpperCase() != 'DEFAULT';
        console.log('pageName:' + pageName + " loaded: " + this.esroloaded);
        Show.iframePage = pageName.toUpperCase();
        this.showThankuPage(pageName);

    };
    loadEsroEvent = (url) => {
        //this._esro.gotoUrl(url+'?interface=1505');
        url = device.mobile ? url + '?interface=4' : url;
        this._esro.gotoUrl(url);
    };
    ticketsCallback = (result) => {
        if(result.HasError) {
            alert("catchTicketCallBack: " + result.ErrorDescription);
        }
        console.log(result);
        var baseUrl = 'https://www.kupat.co.il/';
        this._esro.gotoUrl(baseUrl + 'UserData.aspx'); //UserData.aspx //order.aspx //MyBasket.aspx
        //showiframe();
    };

    attachTicket(ticket, count) {
        var eventGuid = ticket.eventGuid[ticket.type];
        var areaGuid = ticket.areaid[ticket.type];
        var priceTypeId = ticket.priceTypeId[ticket.type];
        var priceLevelId = ticket.priceLevelId[ticket.type];
        this._esro.autoCatchTickets(eventGuid, areaGuid, priceTypeId, priceLevelId, 'GA', count, 'ticketsCallback');

    }
    esroPostCallback(e) {
        if(e.origin === "https://www.kupat.co.il" || "https://kupat.co.il") {
            var eventName = !!e.data.EventName ? e.data.EventName.toLowerCase() : '';

            if(eventName === "load") {
                this.iframePage = e.data.screen.toUpperCase();
                if(this.esroloaded) {
                    $(document).scrollTop($('#showIframe').offset().top);
                }
            }
            if(eventName === "domchanged.esro") {
            }
            if(eventName === "resize") {
            }
            if(eventName === "dialogopen") {
                $(document).scrollTop($('#showIframe').offset().top);
            }
            if(e.data.DocumentHeight != undefined) {
                this.fixIframeHeight(e.data.DocumentHeight);
            }
            if(eventName === "notfound") {
            }
        }

    };

    fixIframeHeight(DocumentHeight) {
        var newheight = Math.round(DocumentHeight);
        var currentHeight = $('#showIframe').height();
        var winW = $(window).height() - 80;

        if(newheight == currentHeight || Math.abs(newheight - currentHeight) < 10) {
            return;
        }
        if(Show.iframeisPopup) {
            newheight = (DocumentHeight > winW && !device.mobile) ? winW : newheight;
        }

        $('#showIframe').height(newheight);

    };

    openIframe(btn) {
        if(typeof this._esro === "undefined") {
            console.log('esro error');
            return;
        }
        if(!Show.validateTimerShow(btn)) {
            return false;
        }

        //removed '?interface=29'
        if($(btn).hasClass('soldout') || $(btn).parent().hasClass('soldout')) {
            //return;
        }
        var show_url = btn.attr('href');
        var id = btn.attr('data-id');
        Show.showStage('iframe');
        Show.loader(true);
        var url = show_url;

        var frame = $('#showIframe')[0];
        frame.contentWindow.location.replace(url);
        Show.iframeSrc = url;

        if(Show.iframeisPopup && !device.mobile) {
            $('#overlay').fadeIn();
            var h = jQuery(window).height() - 80;
            jQuery('iframe#showIframe').css('max-height', h);
            jQuery('#esroIframe').css('max-height', h);
        }

        Show.waitForLoad = true;
        var to = jQuery('#frame').offset().top;
        scrollToPos(to);


    };

    getEsroUrlbyId(id) {
        var url = '';
        if(this.esroEvents === undefined) {
            return;
        }
        for(var i = 0; i < this.esroEvents.length; i++) {
            var e = this.esroEvents[i];
            if(e.EventLocalId == id) {
                var url = e.DirectLink;
                break;
            }

        }
        return url;
    };

    showThankuPage(pageName) {
        if(pageName.toUpperCase() == "SUBMITBASKET.ASPX" || pageName.toUpperCase() == 'CONFIRMATION.ASPX' || pageName.toUpperCase() == 'OPSSUMMARY.ASPX') {
            if(!Show.thankuOpend) {
                Show.thankuOpend = true;
                Show.updateSession(function() {
                    setTimeout(function() {
                        Show.showStage(VIEW_START);
                        dataLayer.push({'event': 'leadSent'});
                        if(this._esro.getSessionState().basket !== null) {
                            dataLayer.push({'tickets': this._esro.getSessionState().basket.Tickets.length});
                        }


                        $.fancybox.open({
                            href      : site.siteUrl + '/thanku?id=' + Show.id,
                            type      : 'iframe',
                            maxWidth  : '95%',
                            maxHeight : '550px',
                            scrolling : 'no',
                            afterShow : function(e) {
                                $('.fancybox-inner').css('overflow', 'hidden');
                            },
                            afterClose: function() {
                                var to = jQuery('#frame').offset().top - 40;
                                scrollToPos(to);
                            }
                        });
                    }, 500);
                });
            }
        }
    };
}


